import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableRemoveCell
} from '../../styled-components/Table';
import LuciPropTypes from '../../propTypes';
import { actions as axisOrderActions } from '../../actions/axisOrder';
import { localizeAxis as localize } from '../../util/localizeUtils';

const TableContainer = styled.div`
  border: 1px solid rgb(87, 118, 160);
  height: 75px;
  overflow: auto;
`;

class ItemList extends Component {
  onSelectRow = (item) => {
    this.props.onSelectItem(item.replaceableId);
  }
  renderRows = (item, index) => {
    return (
      <TableRow key={`${item.title}-${item.replaceableId}`} style={{ height: '18px' }} selected={item.replaceableId === this.props.selectedItemId} onClick={() => this.onSelectRow(item)}>
        <TableCell>{item.title}</TableCell>
        <TableRemoveCell clickable onClick={(evt) => { this.props.onRemoveItem(index); evt.stopPropagation(); }}>
          &times;
        </TableRemoveCell>
      </TableRow>
    );
  }
  renderEmptyRows() {
    const rowsToRenderCount = 4 - this.props.items.length;
    if (rowsToRenderCount > 0) {
      const rows = [];
      for (let i = 0; i < rowsToRenderCount; i++) {
        rows.push(
          <TableRow key={`empty-${i}`} style={{ height: '18px' }}>
            <TableCell>&nbsp;</TableCell>
            <TableRemoveCell />
          </TableRow>
        );
      }

      return rows;
    }
  }
  render() {
    return (
      <div>
        <Table fontSize="8pt" width="100%">
          <TableHeader>
            <TableRow>
              <TableCell colSpan={2}>{localize('itemListHeader')}</TableCell>
            </TableRow>
          </TableHeader>
        </Table>
        <TableContainer>
          <Table fontSize="8pt" width="100%">
            <TableBody>
              {this.props.items.map(this.renderRows)}
              {this.renderEmptyRows()}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }
}

ItemList.defaultProps = {
  selectedItemId: ''
};

ItemList.propTypes = {
  items: PropTypes.arrayOf(LuciPropTypes.AxisOrderItem).isRequired,
  selectedItemId: PropTypes.string,
  onRemoveItem: PropTypes.func.isRequired,
  onSelectItem: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  items: state.axisOrder.items,
  selectedItemId: state.axisOrder.currentItem.replaceableId
});

const mapDispatchToProps = {
  onRemoveItem: axisOrderActions.removeItem,
  onSelectItem: axisOrderActions.startEditItem
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemList);



// WEBPACK FOOTER //
// ./app/components/OrderForm/ItemList.js